import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash-es';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { UserModel } from '../core/models/user/user.model';
import { selectLoggedInUser } from './state/auth.selectors';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private readonly store: Store) {}

  public getLoggedInUserClone(): UserModel {
    let loadedUser: UserModel;
    this.getLoggedInUser()
      .pipe(take(1))
      .subscribe((user) => {
        loadedUser = user;
      });
    return cloneDeep(loadedUser);
  }

  public getLoggedInUser(): Observable<UserModel> {
    return this.store.select(selectLoggedInUser);
  }
}
